<template>
  <div class="shipment-dailog dialog">
    <div class="title">
      <h1>訂單出貨</h1>
    </div>
    <div class="content container">
      <div class="row">
        <div class="col-12">
          <div class="buttons container">
            <input v-show="false"
              type="file"
              id="import"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              extension="xlsx"
              @change="e => fileTypeCheck(e, e => importFileOnChange(e), (e, ea) => addToast('error', '檔案格式有誤，請上傳' + ea.join('/')))">
            <input type="text" v-show="false" name="import" v-model="shipmentFile" v-validate="'required'">
            <div class="mask">
              <label for="import" class="mask" />
              <button class="main-button field-button">
                <span><invisible :size="1" :isFullWidth="true" />匯入出貨單<invisible :size="1" :isFullWidth="true" /></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="shipmentJson">
        <div class="col-12">
          <table class="table-line">
            <tr>
              <th>
                <center :style="{ width: '100%' }">出貨訂單號</center>
              </th>
            </tr>
            <tr v-for="(number, index) in shipmentOrderNumbers" :key="index">
              <td>
                <center :style="{ width: '100%' }">{{ number }}</center>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="buttons container">
            <button class="main-button field-button" :class="{ 'loading': onSubmit }" :disabled="disabled" @click="validateImportOrder()">
              <span><invisible :size="1" :isFullWidth="true" />確認出貨<invisible :size="1" :isFullWidth="true" /></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { postOrderImport } from '../../api'
import invisible from '../tool/invisible'
import toastMethods from '../../mixins/toastMethods'
import { fileTypeCheck, xlsxToJson } from '../../constants/global/util.js'

export default {
  components: {
    invisible
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      shipmentFile: '',
      shipmentJson: null,
      onSubmit: false
    }
  },
  computed: {
    disabled () {
      let value = true
      if (this.errors.items.length === 0) {
        value = false
      }
      if (this.onSubmit) {
        value = true
      }
      return value
    },
    shipmentOrderNumbers () {
      return this.shipmentJson ? this.shipmentJson.map(json => json['用戶訂單號'].replace(/-(.*?)$/, '')).filter((x, i, s) => s.indexOf(x) === i) : []
    },
    // util
    fileTypeCheck: () => fileTypeCheck
  },
  methods: {
    async importFileOnChange (e) {
      this.shipmentFile = e.target.files[0]
      this.shipmentJson = (await xlsxToJson(e.target.files))[0]
      e.target.value = ''
    },
    async validateImportOrder () {
      this.onSubmit = true
      let result = await this.$validator.validateAll()
      if (result) {
        await this.importOrder()
      } else {
        this.addToast('error', '請先匯入出貨單')
        this.onSubmit = false
      }
    },
    async importOrder () {
      try {
        let config = this.$ls.get('userInfo') || {}
        let file = this.shipmentFile
        await postOrderImport(file, config)
        this.addToast('success', '出貨成功')
        this.onSubmit = false
        this.$emit('changeModal', {}, 'delivered')
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.errors[0])
        this.onSubmit = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/shipment.vue